/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { formatISO } from 'date-fns';
// custom components
import NumberedHeading from "../../../../../shared-components/forms/NumberedHeading";
import FocusPointsArray from '../shared/FocusPointsArray';
import EmentorArray from '../shared/EmentorArray';
import ImageAttribution from '../shared/ImageAttribution';
import ReadingAttribution from '../shared/ReadingAttribution';

const Reading = (props) => {

  const { control, formState } = props.methods;
  const { errors } = formState;

  const { inputDir } = props;

  return (
    <div>
      <NumberedHeading number="1" title="Image" instructions="Describe an image that aligns witht the context of this article." required />
      <Controller 
        control={control}
        name="content.media"
        render={({ field }) => <ImageAttribution targetObj="content.media" inputDir={inputDir} errors={errors.content?.media} {...{control }} />}
      />
      <NumberedHeading number="2" title="Reading" instructions="Fill in the data for the Reading." required />
      <Controller 
        control={control}
        name="content.core"
        render={({ field }) => <ReadingAttribution targetObj="content.core" inputDir={inputDir} errors={errors.content?.core} {...{control }} />}
      />

      <NumberedHeading number="3" title="Focus Points" instructions="Add as many focus points as necessary for this reading." required />
      <Controller
        control={control}
        name="content.focus_points"
        render={({ field }) => <FocusPointsArray inputDir={inputDir} {...{ control, errors }} />}
      />

      <NumberedHeading number="4" title="eMentor Notes" instructions="Using the controls below, add any supplemental content to this page" />

      <Controller
        control={control}
        name="content.eMentor"
        render={({ field }) => <EmentorArray {...{ control, errors }} />}
      />

    </div>
  );
};

export default Reading;